import { Grid, styled } from '@mui/material';
import { Fragment } from 'react';
import IncomeTypeTable from './shared/IncomeTypeTable';
import AddIncomeType from './shared/AddIncomeType';
import { useState } from 'react';

const ContentBox = styled('div')(({ theme }) => ({
  margin: '30px',
  [theme.breakpoints.down('sm')]: { margin: '16px' }
}));

const IncomeType = () => {
  const [apiCall, setApiCall] = useState(false);
  function handleApiCall() {
    setApiCall((prev) => !prev);
  }
  return (
    <Fragment>
      <ContentBox className='analytics'>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <AddIncomeType handleApiCall={handleApiCall} />
            <IncomeTypeTable handleApiCall={handleApiCall} apiCall={apiCall} />
          </Grid>
        </Grid>
      </ContentBox>
    </Fragment>
  );
};

export default IncomeType;
